import React, { useEffect } from 'react';
import './Donate.css';
import Donateform from '../dashboard/components/Donateform';
import ReactGA from "react-ga4";
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ImpactBanner from '../components/ImpactBanner/ImpactBanner';

function Donate() {
  const location = useLocation()
  useEffect(()=>{
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Donate Page' });
  }, []);
  return (
    <div style={{display:'flex', flexDirection: 'column',justifyContent:'center', alignItems:'center'}}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Donate</title>
      </Helmet>
      <ImpactBanner/>
      <Donateform />
    </div>
  );
}

export default Donate;